/* eslint-disable vue/no-unused-components */
<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="box column is-6 is-offset-3" id="login-box">
          <h1 class="title has-text-centered">Manager Login</h1>
          <h1 v-if="false" class="title is-5 has-text-centered">ເຂົ້າລະບົບ</h1>
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <div class="field">
                <label class="label">ຊື່ເຂົ້າໃຊ້:</label>
                <div class="control">
                  <input type="text" class="input" v-model="username" />
                </div>
              </div>
              <div class="field">
                <label class="label">ລະຫັດລັບ:</label>
                <div class="control">
                  <input
                    type="password"
                    class="input"
                    v-model="password"
                    @keyup.enter="doLogin"
                  />
                </div>
              </div>

              
              <div class="field">
                <div class="control">
                  <button
                    class="button is-primary is-fullwidth"
                    @click="doLogin"
                  >
                    ເຂົ້າລະບົບ
                  </button>
                </div>
              </div>
              
              <!-- <div class="field">
                <div class="control">
                  <button
                    class="button is-info is-fullwidth"
                    @click="goRegister"
                  >
                    ລົງທະບຽນ
                  </button>
                </div>
              </div> -->
              <div class="field">
                <b-field class="login-fail">
                  {{ this.errorMessage }}
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import restAPI from "./../RestAPI";
import VueJwtDecode from "vue-jwt-decode";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      errorMessage: null,
      role: null,

    };
  },
  methods: {
    gotointerstudent(){
      this.$router.replace("/internstudentform");
    },
    doRegister(){
       this.$router.replace("/register");
    },
    doLogin() {
      // console.log("there....");
      this.errorMessage = null;
      if (!this.validationForm()) {
        return;
      }


  
      const loadingComponent = this.$loading.open({});

      const req = {
        username: this.username,
        password: this.sha2(this.password)
      };
      // console.log("req:" + JSON.stringify(this.username));
      // console.log("113355:" + this.sha2('113355'));  
      // console.log("b59545996:" + this.sha2('b59545996'));  
      // console.log("c55259299:" + this.sha2('c55259299'));  
      // console.log("d76827816:" + this.sha2('d76827816'));  
      // console.log("e94042669:" + this.sha2('e94042669'));  

      restAPI
        .login(req)
        .then(res => {
          // console.log("res: " + JSON.stringify(res.data));
          //console.log("here....", res.data.jwt);
          // console.log("res.data.USERNAME....", res.data.USERNAME);
          this.role = res.data.ROLEID;
          const session = res.data;
          if (typeof res.data === "string") {
            // console.log("error-: " + JSON.stringify(res.data));
            this.errorMessage = JSON.stringify(res.data);
            return;
          }

          // console.log("data-: " + JSON.stringify(res.data));
          // console.log("res.data.ROLEID-: " + JSON.stringify(res.data.ROLEID));

          this.$store.set("token", session.jwt);
          this.$store.set("loginData", session);
          this.$store.set("decodedToken", VueJwtDecode.decode(session.jwt));
          if (res.data.ROLEID == "1") {
            this.$router.replace("/oapp");
          } else if (res.data.ROLEID == "2" || res.data.ROLEID == "3") {
            this.$router.replace("/dpp");
          } else if (res.data.ROLEID == "4") {
            this.$router.replace("/agent");
          } else if (res.data.ROLEID == "5") {
            this.$router.replace("/farmer");
          } else if (res.data.ROLEID == "6" || res.data.ROLEID == "7") {
            this.$router.replace("/dasm");
          } else if (res.data.ROLEID == "9" || res.data.ROLEID == "10") {
            this.$router.replace("/clinic");
          } else if (res.data.ROLEID == "11" || res.data.ROLEID == "12") {
            this.$router.replace("/marketchecker");
          } else if (res.data.ROLEID == "23" || res.data.ROLEID == "24") {
            this.$router.replace("/marketmanager");
          } else if (res.data.ROLEID == "25" || res.data.ROLEID == "26" || res.data.ROLEID == "27" || res.data.ROLEID == "28") {
            this.$router.replace("/icsmain");
          }else if (res.data.ROLEID == "29") {
            this.$router.replace("/marketpurchaser");
          }else if (res.data.ROLEID == "30" || res.data.ROLEID == "31") {
            this.$router.replace("/account/marketcheck");
          }else if (res.data.ROLEID == "301" ) {
            this.$router.replace("/account-stock/marketcheck");
          }else if (res.data.ROLEID == "32") {
            this.$router.replace("/agrilao/profitreport");
          
          }else if (res.data.ROLEID == "77") {
            this.$router.replace("/dasm/b2bcontractpurchasewaiter");
          
          }else if (res.data.ROLEID == "78") {
            this.$router.replace("/stock/stockoutwait");
          
          }
          // else if (res.data.ROLEID == "32" || res.data.ROLEID == "33") {
          //   this.$router.replace("/issue");
          // }
          else {
            this.errorMessage = "ບໍ່ສາມາດເຂົ້າລະບົບໄດ້";
            return false;
          }
        })
        .catch(err => {
          if (err.response) {
            console.log("err-: " + err.response);
          } else {
            console.log("err+:" + err);
          }
        })
        .then(() => {
          loadingComponent.close();
        });
    },
    goRegister(){
      this.$router.replace("/register");
    },
    validationForm() {
      if (
        this.username === null ||
        this.username.length == 0 ||
        this.password === null ||
        this.password.length == 0
      ) {
        this.errorMessage = "ປ້ອນຊື່ເຂົ້າລະບົບ ແລະ/ຫຼື ລະຫັດລັບ ໃຫ້ຄົບ!";
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.$store.set("token", null);
    this.$store.set("loginData", null);
    this.$store.set("decodedToken", null);
  }
};
</script>

<style scoped>
#login-box {
  padding: 20px;
  margin-top: 100px;
}
.login-fail{
  color:red;
}
</style>
